export const graphFormConfig = [
  {
    id: 1,
    graph_label: "On / Off /Idle",
    fields: [
      {
        id: 1,
        label: "On Time",
        meta: [],
        required: true,
      },
      {
        id: 2,
        label: "Off Time",
        required: true,
        meta: [],
      },
      {
        id: 3,
        label: "Idle Time",
        required: true,
        meta: [],
      },
    ],
  },
  {
    graph_label: "Count",
    id: 2,
    fields: [
      {
        id: 4,
        label: "Count",
        required: true,
        meta: [
          {
            label: "Expected count",
            type: "number",
            key: "expected_count",
            placeholder: "Enter Counts",
          },
        ],
      },
    ],
  },
  {
    id: 3,
    graph_label: "Avg On time",
    fields: [
      {
        id: 5,
        label: "Open Time",
        required: true,
        meta: [],
      },
    ],
  },
  {
    id: 4,
    graph_label: "Avg Off time",
    fields: [
      {
        id: 6,
        label: "Close Time",
        required: true,
        meta: [],
      },
    ],
  },
  {
    id: 5,
    graph_label: "Power consumption",
    fields: [
      {
        id: 7,
        label: "Kwh",
        required: false,
        meta: [],
      },
    ],
  },
  {
    id: 6,
    graph_label: "Status",
    fields: [
      {
        id: 8,
        label: "Machine Status",
        required: false,
        meta: [],
      },
      {
        id: 9,
        label: "Supply Status",
        required: false,
        meta: [],
      },
    ],
  },
];
